import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Form, Input, Button, DatePicker, message } from 'antd';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { get } from '../../../api/commonAPI';
import { getPromoCodeUsage } from './PromoCodeAction';

const { RangePicker } = DatePicker;

const BookingTable = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const bookings = useSelector(state => state.promoCode?.promoCodeUsage || []);
  const [loading, setLoading] = useState(false);
  const [btndisabled, setbtndisabled] = useState(true);

  const handleFetchData = (values) => {
    const { promoCode, dateRange } = values;
    if (!promoCode || !dateRange) {
      message.error('Please provide all required fields.');
      return;
    }
    const [startDate, endDate] = dateRange;
    dispatch(getPromoCodeUsage(promoCode,startDate.format('DD-MM-YYYY'),endDate.format('DD-MM-YYYY')));
  };

  const handleExportExcel = async (promoCode, startDate, endDate) => {
    if (bookings.data.length === 0) {
      message.error('No data available to export.');
      return;
    }
  
    const totalBookings = bookings.data.reduce((sum, user) => sum + user.bookingCount, 0);
  
    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Bookings');
  
    // Define border style
    const borderStyle = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' },
    };
  
    // Add Summary Section
    const summaryData = [
      ['Promo Code:', promoCode || 'N/A'],
      ['Start Date:', startDate ? moment(startDate).format('YYYY-MM-DD') : 'N/A'],
      ['End Date:', endDate ? moment(endDate).format('YYYY-MM-DD') : 'N/A'],
      ['Total Booking Count:', totalBookings],
      [],
    ];
  
    summaryData.forEach((row, index) => {
      const addedRow = worksheet.addRow(row);
      addedRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4CAF50' }, // Green background
        };
        cell.border = borderStyle;
        cell.alignment = { vertical: 'middle', horizontal: 'left' };
      });
    });
  
    // Add Header Row
    const headerRow = worksheet.addRow([
      'User Name',
      'User Email',
      'Booking Count',
      'Booking ID',
      'Created Date (YYYY-MM-DD HH:mm)',
    ]);
  
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF2196F3' }, // Blue background
      };
      cell.border = borderStyle;
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });
  
    // Populate Data Rows
    bookings.data.forEach((usage) => {
      const userRow = worksheet.addRow([
        usage.userName,
        usage.email,
        usage.bookingCount,
        '', // Placeholder for booking ID
        '', // Placeholder for created date
      ]);
  
      userRow.eachCell((cell) => {
        cell.border = borderStyle;
      });
  
      usage.bookings.forEach((booking) => {
        const bookingRow = worksheet.addRow([
          '', // Align under User Name
          '', // Align under User Email
          '', // Align under Booking Count
          booking.bookingId,
          moment(booking.createdDate).format('YYYY-MM-DD HH:mm'),
        ]);
  
        bookingRow.eachCell((cell) => {
          cell.border = borderStyle;
        });
      });
  
      worksheet.addRow([]); // Spacer row
    });
  
    // Auto width for columns
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 20 ? 20 : maxLength;
    });
  
    // Generate Excel File
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Bookings_Report_${promoCode}_${moment(startDate).format('YYYY-MM-DD')}_${moment(endDate).format('YYYY-MM-DD')}.xlsx`);
  };

  const columns = [
    {
      title: 'User Name',
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: 'User Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Booking Count',
      dataIndex: 'bookingCount',
      key: 'bookingCount',
    },
    {
      title: 'Bookings',
      dataIndex: 'bookings',
      key: 'bookings',
      render: (bookings) => (
        <Table
          dataSource={bookings}
          columns={[
            {
              title: 'Booking ID',
              dataIndex: 'bookingId',
              key: 'bookingId',
            },
            {
              title: 'Created Date',
              dataIndex: 'createdDate',
              key: 'createdDate',
              render: (date) => moment(date).format('YYYY-MM-DD HH:mm'),
            },
          ]}
          pagination={false}
          rowKey="bookingId"
        />
      ),
    },
  ];

  const onValuesChange = (changedValues, allValues) => {
    console.log(allValues);
    if ( allValues.promoCode != undefined && allValues.dateRange?.startDate != undefined && allValues.dateRange?.endDate != undefined && allValues.promoCode != '' && allValues.dateRange?.startDate != '' && allValues.dateRange?.endDate != '') {
      setbtndisabled(false);
      console.log(false);
    } else {
      setbtndisabled(true);
      console.log(true);
    }
  };

  return (
    <div>
      <h1>Bookings</h1>
      <Form
        form={form}
        layout="inline"
        onFinish={handleFetchData}
        onValuesChange={console.log('jo')}
        style={{ marginBottom: '20px' }}
      >
        <Form.Item
          name="promoCode"
          label="Promo Code"
          rules={[{ required: true, message: 'Please input promo code!' }]}
        >
          <Input placeholder="Enter promo code" />
        </Form.Item>
        <Form.Item
          name="dateRange"
          label="Date Range"
          rules={[{ required: true, message: 'Please select date range!' }]}
        >
          <RangePicker />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} >
            Fetch Bookings
          </Button>
        </Form.Item>
        <Form.Item>
        <Button
          type="default"
          onClick={() => handleExportExcel(form.getFieldValue('promoCode'), form.getFieldValue('dateRange')?.[0], form.getFieldValue('dateRange')?.[1])}
          disabled={bookings.data.length === 0}
        >
          Export as Excel
        </Button>
        </Form.Item>
      </Form>
      <><Table dataSource={bookings.data} columns={columns} loading={loading} rowKey="email" bordered/> </>
    </div>
  );
};

export default BookingTable;
